import { UserProfile } from "@interfaces/userProfile.interface";

export function AvatarForUserProfile(userProfile: UserProfile) {
	if (userProfile != null && userProfile != undefined) {
		if (userProfile.profileImage != null && userProfile.profileImage != undefined && userProfile.profileImage != "") {
			return userProfile.profileImage;
		}
		if (userProfile.firstName != undefined && userProfile.lastName != undefined) {
			return "https://ui-avatars.com/api/?name=" + userProfile.firstName.substring(0,1) + "+" + userProfile.lastName.substring(0,1) + "&size=512&background=344281&color=ffffff";
		}
	}
	return "https://ui-avatars.com/api/?name=??&size=512&background=330000&color=ffffff";
}